<template>
    <div class="img-outer">
        <img src="../assets/image/loader.gif" class="loader" />
    </div>
</template>

<script>
export default {
    name: "LoaderComponent"
}
</script>

<style lang="scss" scoped>

.img-outer{
    margin: auto;

}
.loader{
    width: 40px;
    display: block;
    margin:  auto;
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>